// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';

import Menu from './Menu'

export default class SuggestedItem extends ApiObject {

  /**
   *
   * @type {{CMENU: number, PRODUCT: number}}
   */
  static Type = {
    MENU: 1,

    PRODUCT: 2,
  };

  static Action = {
    REPLACE: 0,

    ADD: 1,
  };

  id: string;

  type: number;

  action: number;

  setTypeForObject(item) {
    this.type = item instanceof Menu ?
      SuggestedItem.Type.MENU :
      SuggestedItem.Type.PRODUCT;
  }

  isActionReplace(): boolean {
    return this.action === SuggestedItem.Action.REPLACE;
  }

  isActionAdd(): boolean {
    return this.action === SuggestedItem.Action.ADD;
  }

  isMenu(): boolean {
    return this.type === SuggestedItem.Type.MENU;
  }

  isProduct(): boolean {
    return this.type === SuggestedItem.Type.PRODUCT;
  }
}
